export default __webpack_public_path__ + "static/media/braces-fixos.94fde03c.png";